define(function (require) {

    window.lpTag = window.lpTag || {};
    window.lpTag.WebAgent = window.lpTag.WebAgent || {};

    var BaseController = require('web-agent-assets-js/BaseController');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var Operators = require('web-agent-assets-js/lpOperators');
    var Skills = require('web-agent-assets-js/lpSkills');
    var privilegesController = require('web-agent-assets-js/lpPrivilegesController');
    var agentLEManager = require('web-agent-utils/agentLEManager');

    var ENTITY_TYPE = {
        SKILLS: 'skills',
        OPERATORS: 'operators'
    };

    var OPERATORS_SOURCES = {
        UNDER_MANAGEMENT : 'operators.underManagementArray',
        IN_GROUP         : 'operators.inGroupArray',
        LOGGED_IN_AGENT  : 'operators.loggedInUser',
    };

    /////////////////////////////////// PRIVATE VARIABLES ///////////////////////////////////

    var logger;
    var operatorsApi, skillsApi;
    var model;
    var isLPA, needAllOperatorsList, hasSupporDeletedUsersFeature, isAgentManager,isAgent, hasCanSeeOtherConversationsFeature;
    /////////////////////////////////// INITIALIZATION ///////////////////////////////////

    lpTag.lpOperatorAndSkillsController = BaseController.extend(function (options) {
        logger = this.logger || WebAgentLogger.getLogger(this.applicationType);
        model = options && options.model;
        operatorsApi = new Operators();
        skillsApi = new Skills();

        // Setting Flags.
        isLPA                               = window.lpTag.WebAgent.logicController.isLPA()                         ;
        hasSupporDeletedUsersFeature        = agentLEManager.getLEConfig().supportDeletedUsers                      ;
        isAgentManager                      = privilegesController.hasAgentManagerModulePrivilege()                 ;
        isAgent                             = privilegesController.hasAgentViewPrivilege()                          ;
        hasCanSeeOtherConversationsFeature  = privilegesController.hasViewAllChatsPrivilege()                       ;

        // IN CQM - When Agent Manager or Can View Other - Need the Whole List for the Open Connection Table.
        needAllOperatorsList                =  (isAgentManager || hasCanSeeOtherConversationsFeature) && window.lpTag.WebAgent.logicController.needAllOperatorsDataList();

        // This will listen to records changes in the array and re-calculate the count and data objects.
        this.model.bind(ENTITY_TYPE.OPERATORS + '.array', updateModelDataFromArray.bind(this, ENTITY_TYPE.OPERATORS, getSingleOperatorObject));
        this.model.bind(ENTITY_TYPE.SKILLS    + '.array', updateModelDataFromArray.bind(this, ENTITY_TYPE.SKILLS   , getSingleSkillObject    ));

        // Retrive The Logged In User and Add to the List
        if(isAgent){
            this.model.bind(OPERATORS_SOURCES.LOGGED_IN_AGENT   , handleExtenralOperatorArray.bind(this));
        }
        // Retrive all Of the Operators under Management of the logged in agent
        if(isAgentManager){
            this.model.bind(OPERATORS_SOURCES.UNDER_MANAGEMENT  , handleExtenralOperatorArray.bind(this));
        }
        // Retrive All of the Assigned Group Operators if has the feature.
        if(hasCanSeeOtherConversationsFeature){
            this.model.bind(OPERATORS_SOURCES.IN_GROUP          , handleExtenralOperatorArray.bind(this));
        }

    });
    var lpOperatorAndSkills = lpTag.lpOperatorAndSkillsController;

    /////////////////////////////////// PUBLIC INSTANCE VARIABLES ///////////////////////////////////

    lpOperatorAndSkills.prototype.applicationType = 'lpOperatorAndSkillsController';

    /////////////////////////////////// PUBLIC METHODS ///////////////////////////////////

    /**
     * Starts polling the operators and skills (every 60 seconds)
     */
    lpOperatorAndSkills.prototype.startPolling = function () {
        logger.info("", "startPolling");
        getSkills();
        // LPA has no AC Definition, Always get all Operators.
        if( isLPA || needAllOperatorsList ){
            getOperators();
        }
    };

    /**
     * Stops polling the operators and skills
     */
    lpOperatorAndSkills.prototype.stopPolling = function () {
        logger.info("", "stopPolling");
        operatorsApi.stopPolling();
        skillsApi.stopPolling();
    };

    /////////////////////////////////// PRIVATE METHODS ///////////////////////////////////
    /**
     * Handle Incomming data from external sources and normelize it into
     * the main operators array.
     * @param {*} data - event holding structured data for operator.
     */
    function handleExtenralOperatorArray(data){
        var eventData = data.newValue;
        if(eventData){
            var extenalOperatorsList = eventData.constructor === Array ? eventData : [eventData];
            var proccessedData = getProcessedObject(extenalOperatorsList, getSingleOperatorObject);
            var dataArray = _.values(proccessedData);
            this.model.modify("operators.array", dataArray, "id");
        }
    }

    /**
     * Update the model data based on the array, this will allow updating the data from multiple sources.
     * @param {String} name - the name of the data set in the model.
     */
    function updateModelDataFromArray(name, getSingleObject){
        var dataArray = model.get(name + '.array');
        if(dataArray){
            model.set(name + '.count', dataArray.length);
            var processedData = getProcessedObject(dataArray, getSingleObject);
            model.modify(name + '.data', processedData);
            model.set(name + '.state', {success: 'ok', itemsCount: dataArray.length});

        }
    }

    /**
     * Handles a successful request callback by processing the data using the provided callback,
     * and storing the data in the model.
     * @param data - The data returned in the response
     * @param name - The name to store the processed data under in the model
     * @param getSingleObject - The callback to process the data
     */
    function handleRequestSuccess(data, name) {
        var rawData = data.constructor === Array ? data : [data];
        if(name === ENTITY_TYPE.OPERATORS && (needAllOperatorsList || isLPA) ){
            var proccessedData = getProcessedObject(rawData, getSingleOperatorObject);
            var dataArray = _.values(proccessedData);
            model.modify('operators.all', dataArray, "id");
            model.modify('operators.data', proccessedData);
            // LPA is not part of the AC, his "Exposed List" is the entire operators list.
            if((isLPA)){
                model.modify('operators.array', dataArray, "id");
            }
        }else{
            model.modify(name + '.array', rawData, "id");
        }
    }

    /**
     * Handles a request error by saving the error data to the model.
     * @param data - The error data
     * @param name - The name to store the data under in the modle.
     */
    function handleRequestError(data, name) {
        model.set(name + '.state', {error: data || ''});
    }

    /**
     * Returns processed data based on an array of raw data and a callback used to process each item in the array.
     * @param rawArray - An array of raw data to be processed into an object by ID
     * @param getSingleObject - The callback to process a single item in the raw data array
     * @returns - An object containing processed objects by ID
     */
    function getProcessedObject(rawArray, getSingleObject) {
        var dataArray = rawArray;
        var processedObject = {};
        for (var i = 0; i < dataArray.length; i++) {
            var singleObject = getSingleObject(dataArray[i]);
            processedObject[dataArray[i].id] = singleObject;
            if(!dataArray[i].proccessed){
                dataArray[i].fullName = singleObject.fullName;
                dataArray[i].displayName = singleObject.displayName;
            }
        }
        return processedObject;
    }

    /**
     * Starts polling the operators (The API starts polling internally)
     */
    function getOperators() {
        logger.info("", "getOperators");
        var requestObj = {
            success: handleOperatorsSuccess,
            error: handleOperatorsError
        };
        operatorsApi.getOperators(requestObj);
    }

    /**
     * Handles the success of an operators request
     * @param data - The raw operators data
     */
    function handleOperatorsSuccess(data) {
        logger.debug("Operators return as Success", "handleOperatorsSuccess");
        if(data && data.statusCode !== 304){
            var dataToUse = [];
            if (data && data.body) {
                dataToUse = data.body;
            }
            handleRequestSuccess(dataToUse, ENTITY_TYPE.OPERATORS, getSingleOperatorObject);
        }
    }

    /**
     * Handles an error in an operators request
     * @param data - The error data
     */
    function handleOperatorsError(data) {
        logger.error(JSON.stringify(data), "handleOperatorsError");
        logger.graph({name: 'getOperatorsError'});
        handleRequestError(data, ENTITY_TYPE.OPERATORS);
    }

    /**
     * Maps a single operator object from its raw form to its final form
     * @param operatorObject - The raw operator object
     * @returns - The processed operator object
     */
    function getSingleOperatorObject(operatorObject) {
        if(operatorObject.processed) {
            return operatorObject;
        }

        var displayName     = operatorObject.displayName || operatorObject.fullName; //lpTag.WebAgent.logicController.isAccountConfigUsersEnabled() ? operatorObject.fullName : operatorObject.displayName;
        var nickName        = operatorObject.nickname || operatorObject.nickName;
        var fullName        = nickName + " (" + displayName + ")";
        var agentGroupId    = (operatorObject.memberOf && operatorObject.memberOf.agentGroupId) || operatorObject.agentGroupId;

        return {
            id: +operatorObject.id,
            pid: operatorObject.pid,
            displayName: displayName,
            nickName: nickName,
            loginName: operatorObject.loginName,
            fullName: fullName,
            skillIds: operatorObject.skillIds,
            agentGroupId: agentGroupId,
            deleted: operatorObject.deleted,
            processed: true,
        };
    }

    /**
     * Starts polling the skills (The API starts polling internally)
     */
    function getSkills() {
        logger.info("", "getSkills");
        var requestObj = {
            success: handleSkillsSuccess,
            error: handleSkillsError
        };
        skillsApi.getSkills(requestObj);
    }

    /**
     * Handles the success of an skills request
     * @param data - The raw skills data
     */
    function handleSkillsSuccess(data) {
        logger.debug("Skills return as Success", "handleSkillsSuccess");
        if(data && data.statusCode !== 304){
            var dataToUse = [];
            if (data && data.body) {
                dataToUse = data.body;
            }
            handleRequestSuccess(dataToUse, 'skills', getSingleSkillObject);
        }
    }

    /**
     * Handles an error in an skills request
     * @param data - The error data
     */
    function handleSkillsError(data) {
        logger.error(JSON.stringify(data), "handleSkillsError");
        logger.graph({name: 'getSkillsError'});
        handleRequestError(data, 'skills');
    }

    /**
     * Maps a single skill object from its raw form to its final form
     * @param skillObject - The raw skill object
     * @returns - The processed skill object
     */
    function getSingleSkillObject(skillObject) {
        return {
            id: skillObject.id,
            name: skillObject.name,
            description: skillObject.description,
            canTransfer: skillObject.canTransfer,
            skillTransferList: skillObject.skillTransferList
        };
    }

    return lpTag.lpOperatorAndSkillsController;

});
